import React from 'react';
import {Modal} from 'react-bootstrap';
import TextField from './../Textfield';
import Checkbox from './../Checkbox';
import Button from './../Button'
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

var imm = require('immutable');
var RandExp = require('randexp');

const customStyles = {
    content : {
        top                   : '50%',
        left                  : '50%',
        right                 : 'auto',
        bottom                : 'auto',
        marginRight           : '-50%',
        transform             : 'translate(-50%, -50%)'
    }
};

class ModalBody extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            modalIsOpen: false,
            errors: [],
            data: imm.Map(),
            options: imm.Map(),  // for select fields
            defaults: imm.Map(),  // default values
            fields: [],
            remotemeta: [],
            errorfields: [],
        }
    }

    componentDidUpdate() {
        {
            this.props.metadata.map(function (fields, i) {
                if (fields.default === 'RANDOM' && this.state.data.get(fields.source) === 'RANDOM') {
                    this.setState((state) => ({
                        data: state.data.set(fields.source, new RandExp(`${fields.pattern}`).gen())
                    }));
                }
                if (typeof(fields.default) == 'object') {
                    if (fields.default.type === 'metadata') {
                        var defdata = undefined;
                        if (fields.default.data !== undefined) {
                            var datafld = fields.default.data;
                            if (this.state.remotemeta[datafld] !== undefined) {
                                defdata = this.state.remotemeta[datafld].default;
                            }
                        }
                        if (defdata !== undefined && typeof(this.state.data.get(fields.source)) == 'object') {
                            this.setState((state) => ({
                                data: state.data.set(fields.source, defdata)
                            }));
                        }
                    }
                }
            }, this)
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.metadata !== undefined) {
            var newdata = imm.Map();
            nextProps.metadata.map(function (cols, i) {
                if ("default" in cols) {
                    //if (cols.type == 'multiple') {  // convert array to string for simple multiselect
                    //    newdata = newdata.set(cols.source, cols.default.toString());
                    if (cols.type === 'datetime') {
                        if (cols.default === 'NOW') {
                            newdata = newdata.set(cols.source, new Date());   //2017-05-18T00:00:00+03:00
                        }
                    } else {
                        newdata = newdata.set(cols.source, cols.default);
                    }
                }
            }, this);
            this.setState({data: newdata, defaults: newdata});
        }
        // load remote metadata
        if (nextProps.remotemeta !== undefined) {
            this.setState({remotemeta: nextProps.remotemeta});
            var newopt = this.state.options;
            for (var i in nextProps.remotemeta) {
                var col = nextProps.remotemeta[i]
                newopt = newopt.set(i, col.values);
            };
            this.setState({
                options: newopt
            });
        }
    }
    componentDidMount(){
        this.prepareRemoteData();
    }
    prepareRemoteData() {
        // load any select options from server
        this.props.metadata.map(function(fields, i) {
            if (fields.type === undefined) {
                var ftype = fields.type_add;
            } else {
                var ftype = fields.type;
            }
            if (ftype === 'select') {
                if (typeof(fields.default) == 'object') {
                    if (fields.default.type === 'uri') {
                        this.loadSelectData(fields.source, fields.default.data, fields.default.params);
                    }
                }
            }
        }, this);
    }
    loadSelectData(source, url, params) {
        this.props.childProps.dataProvider.getList(url, {}, this.props)
            .then(
                response =>
                    this.setState((state) => ({
                        options: state.options.set(source, response.data.data)
                    }))
            );
    }

    handleClick() {
        this.prepareRemoteData();
        this.setState({modalIsOpen: true});
    }
    handleCancel() {
        this.prepareRemoteData();
        this.setState({
            modalIsOpen: false,
            data: this.state.defaults,
            errorfields: []
        });
    }
    handleSelectChange(key, value) {
        var val = value.value;
        this.setState((state) => ({
            data: state.data.set(key, val)
        }));
    }
    handleMultiSelectChange(key, value) {
        if (value === null) {
            this.setState((state) => ({
                data: state.data.set(key, "")
            }));
        } else {
            let newvals = ""
            for (var i = 0; i < value.length; i++) {
                newvals = newvals.concat(",", value[i].value)
            }
            this.setState((state) => ({
                data: state.data.set(key, newvals)
            }));
        }
    }
    handleChange(key, value) {
        this.setState((state) => ({
            data: state.data.set(key, value)
        }));
    }
    handleDateChange(key, value) {
        this.setState((state) => ({
            data: state.data.set(key, value)
        }));
    }

    handleSave(e) {
        this.setState({errorfields: []});
        var data = this.state.data.toJS();
        this.props.childProps.dataProvider.create(this.props.url, {
            id: this.props.id,
            data: data,
            previousData: data
        }, this.props)
            .then((response, id) => {
                toast.success('Entry Added Successfully', {})
                response.data[this.idCol()] = response.data.id;
                let resp = this.state.defaults;
                if (response.data.response !== undefined) {
                    resp = response.data.response;
                }
                this.setState({
                    data: imm.Map(this.state.defaults),
                    modalIsOpen: false
                }, this.props.onRowAdded(resp))
            }).catch(
            (err)=> {
                toast.error(this.errorMessage(err.message), {})
                var result = err.message;
                let flds = []
                if (result !== undefined && result.fields !== undefined) {
                    flds = result.fields;
                }
                this.setState({
                    errorfields: flds
                });
            })
        this.prepareRemoteData();
    }

    idCol() {
        let idcol = "id";
        this.props.metadata.map(function (mrow, mindex) {
            if(mrow.label === "id") {
                idcol = mrow.source;
            }
        }, this);
        return idcol;
    }

    errorMessage(message) {
        if (message === undefined) {
            return "Backend Error";
        }
        let errstr = message.msg;
        errstr = (errstr === undefined) ? "Backend Error": errstr;
        for (let i in message.fields) {
            var fieldname = message.fields[i];
            this.props.metadata.map(function (mrow) {
                if (mrow.source === fieldname) {
                    errstr = errstr.replace(/%s/gi, mrow.label);
                }
            }, this);
        }
        return errstr;
    }

    render() {
        let addButton;
        let buttonValue = "Add New";
        if (this.props.addButtonValue) {
            buttonValue = this.props.addButtonValue;
        }
        if (this.props.addButton) {
            addButton = <Button
                bsStyle={ this.props.bsStyle ? this.props.bsStyle: "btn-default"}
                value={buttonValue}
                icon = "add"
                onClick={this.handleClick.bind(this)}
            />
        }
        if (this.props.metadata === undefined)
            return null;
        return(
            <div>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    closeOnClick={true}
                    pauseOnHover={true}
                    draggable={true}
                    progress="undefined"
                />
                <div style={{marginBottom: '10px'}}>
                    {addButton}
                </div>
                <Modal show={this.state.modalIsOpen} onHide={this.handleCancel.bind(this)} style={customStyles}>
                    <Modal.Header closeButton>
                        <Modal.Title>{buttonValue}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form className="form-horizontal">
                            <div className="row">
                                <div className="col-lg-12">
                                    {
                                        this.props.metadata.map(function(fields, i) {

                                            const ftype = fields.type === undefined ? fields.type_add : fields.type;
                                            const ef = this.state.errorfields.indexOf(fields.source);
                                            const src = fields.source;
                                            let formclass = 'form-group';
                                            if (ef > -1) {
                                                formclass = 'form-group has-error';
                                            }
                                            let meta = {};
                                            meta = this.state.remotemeta[fields.source];
                                            if (meta === undefined) {
                                                meta = {};
                                            }
                                            if (fields.visible === false)
                                                return false;
                                            if (fields.visible_add === false)
                                                return false;
                                            if (ftype === "primary") {
                                                return null;
                                            } else if (ftype === "button_delete") {
                                                return null;
                                            } else if (ftype === "button_edit") {
                                                return null;
                                            } else if (ftype === "action_buttons") {
                                                return null;
                                            } else if (ftype === "link") {
                                                return null;
                                            } else if (ftype === "random") {
                                                return (
                                                    <div key={i} className={formclass}>
                                                        <label
                                                            className="col-sm-4 control-label"
                                                            htmlFor={fields.source}>{fields.label}</label>
                                                        <div className="col-sm-8">
                                                            <TextField
                                                                label=''
                                                                type='text'
                                                                value={ this.state.data.get(src) }
                                                                placeholder={ fields.placeholder }
                                                                onChange={ this.handleChange.bind(this, src) }
                                                                error = {this.state.errors.src}
                                                                className="form-control"
                                                                readOnly = { !fields.editable }
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                            } else if (ftype === "datetime") {
                                                let d = this.state.data.get(src);
                                                let dd = new Date(this.state.data.get(src));
                                                if (d === "NOW") {
                                                    dd = new Date();
                                                }
                                                return (
                                                    <div key={i} className={formclass}>
                                                        <label
                                                            className="col-sm-4 control-label"
                                                            htmlFor={fields.source}>{fields.label}</label>
                                                        <div className="col-sm-8">
                                                            <DatePicker
                                                                className="form-control datepicker"
                                                                selected={ dd }
                                                                onChange={ this.handleDateChange.bind(this, src) }
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                            } else if (ftype === "checkbox") {
                                                return (
                                                    <div key={i} className={formclass}>
                                                        <label
                                                            className="col-sm-4 control-label"
                                                            htmlFor={fields.source}>{fields.label}</label>
                                                        <div className="col-sm-8">
                                                            <Checkbox
                                                                label=''
                                                                type='text'
                                                                checked={ this.state.data.get(src) }
                                                                placeholder={ fields.placeholder }
                                                                onChange={ this.handleChange.bind(this, src) }
                                                                error = {this.state.errors.src}
                                                                className="form-control"
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                            } else if (ftype === "select") {
                                                var options = [];
                                                var defaultValue = {value: 0, label: '--'};
                                                var currentValue = {value: 0, label: '--'};
                                                if (this.state.options.get(src) !== undefined) {
                                                    var opt = this.state.options.get(src);
                                                    Object.keys(opt).map(function (i) {
                                                        options.push({value: i, label: opt[i]});
                                                        if (i === fields.default) {
                                                            defaultValue = {value: i, label: opt[i]}
                                                        }
                                                        if (i === this.state.data.get(src)) {
                                                            currentValue = {value: i, label: opt[i]}
                                                        }
                                                    }, this);
                                                }
                                                return (
                                                    <div key={i} className={formclass}>
                                                        <label
                                                            className="col-sm-4 control-label"
                                                            htmlFor={fields.source}>{fields.label}</label>
                                                        <div className="col-sm-8">
                                                            <Select
                                                                name={fields.source}
                                                                options={options}
                                                                defaultValue={defaultValue}
                                                                value={currentValue}
                                                                id={fields.source}
                                                                placeholder={fields.placeholder}
                                                                onChange={this.handleSelectChange.bind(this, src)}
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                            } else if (ftype == "multiple") {
                                                var options = [];
                                                var defaultValue = [];
                                                var currentValue = [];
                                                var vals = this.state.data.get(src);
                                                if (this.state.options.get(src) !== undefined) {
                                                    var opt = this.state.options.get(src);
                                                    Object.keys(opt).map(function (i) {
                                                        options.push({value: i, label: opt[i]});
                                                        if (fields.default.indexOf(i) >= 0) {
                                                            defaultValue.push({value: i, label: opt[i]})
                                                        }
                                                        if (vals !== undefined && vals.indexOf(i) >= 0) {
                                                            currentValue.push({value: i, label: opt[i]})
                                                        }
                                                    }, this);
                                                }
                                                return (
                                                    <div key={i} className={formclass}>
                                                        <label
                                                            className="col-sm-4 control-label"
                                                            htmlFor={fields.source}>{fields.label}</label>
                                                        <div className="col-sm-8">
                                                            <Select
                                                                name={fields.source}
                                                                options={ options }
                                                                selected={fields.default}
                                                                isMulti
                                                                id={fields.source}
                                                                placeholder={fields.placeholder}
                                                                defaultValue={defaultValue}
                                                                value={currentValue}
                                                                onChange={this.handleMultiSelectChange.bind(this, src)}
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                            } else {
                                                return (
                                                    <div key={i} className={formclass}>
                                                        <label
                                                            className="col-sm-4 control-label"
                                                            htmlFor={fields.source}>{fields.label}</label>
                                                        <div className="col-sm-8">
                                                            <TextField
                                                                label=''
                                                                type='text'
                                                                value={ this.state.data.get(src) }
                                                                placeholder={ fields.placeholder }
                                                                onChange={ this.handleChange.bind(this, src) }
                                                                error = {this.state.errors.src}
                                                                className="form-control"
                                                                readOnly = { !fields.editable }
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        }, this)
                                    }
                                </div>
                            </div>
                        </form>
                    </Modal.Body>
                    <Modal.Footer>
                        <div>
                            <Button bsStyle="btn btn-cancel" value="Cancel" onClick={this.handleCancel.bind(this)}/>
                            <Button bsStyle="btn btn-save" value="Save" onClick={this.handleSave.bind(this)}/>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default class AddFormModal extends React.Component {
    render(){
        return (
            <div>
                <ModalBody
                    data={this.props.data}
                    metadata={this.props.metadata}
                    url={this.props.url}
                    urlattrs={this.props.urlattrs}
                    remotemeta={this.props.remotemeta}
                    addButton={this.props.addButton}
                    addButtonValue={this.props.addButtonValue}
                    bsStyle = { this.props.bsStyle }
                    onRowAdded={this.props.onRowAdded}
                    {...this.props}
                />
            </div>
        );
    }
}
